<ng-container *ngIf="pendingUserAccess; else mainData">
    <div class="data-loader">
        <app-loader></app-loader>
    </div>
</ng-container>

<ng-template #mainData>
    <router-outlet></router-outlet>
</ng-template>